import React, { useState, useEffect, useCallback } from "react";
import { useAPIs } from "../apis/APIsConfig";
import { isFallecido, sendDeceasedAffiliateEmail } from "../services/affiliate";
import { useForm } from "../utils/hooks";
import InputMask from "react-input-mask";
import WithMainLayout from "../hocs/layouts/MainLayout";
import Constants from "../utils/constants";
import { logQuery, QueryResponseCode } from "../services/queryLog";

const DeceasedAffiliate = () => {
  useAPIs();

  const [formState, setError, changeHandler, reset] = useForm({
    Cedula: "",
  });
  const [fallecido, setFallecido] = useState<any>();
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [customMessage, setCustomMessage] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Add state for contact form
  const [contactForm, setContactForm] = useState({
    nombres: "",
    apellidos: "",
    documento: "",
    telefono: "",
    telefonoOpcional: "",
    correo: "",
    parentesco: "",
    confirmacion: false
  });
  const [contactError, setContactError] = useState("");
  //const [contactSuccess, setContactSuccess] = useState("");
  const [contactLoading, setContactLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const sanitizeIdentifier = useCallback((value: string) => value.replace(/\D/g, ""), []);

  const fireAndForgetLog = useCallback(
    ({
      serviceKey,
      identifier,
      responseCode,
      responseMessage,
      responsePayload,
    }: {
      serviceKey: string;
      identifier?: string;
      responseCode: QueryResponseCode;
      responseMessage: string;
      responsePayload?: unknown;
    }) => {
      const payload = {
        serviceKey,
        identifier: identifier ?? "",
        queryAt: new Date().toISOString(),
        responseCode,
        responseMessage,
        responsePayload:
          responsePayload === undefined || responsePayload === null
            ? null
            : typeof responsePayload === "string"
            ? responsePayload
            : JSON.stringify(responsePayload),
        source: "PORTAL_WEB",
      };

      logQuery(payload).catch((error) => {
        console.warn("No se pudo registrar la consulta en la bitácora.", error);
      });
    },
    []
  );

  useEffect(() => {
    fireAndForgetLog({
      serviceKey: "FALLECIDOS_VISITA",
      responseCode: "OK",
      responseMessage: "Pantalla de consulta de fallecidos cargada.",
      identifier: "VISITA",
      responsePayload: null,
    });
  }, [fireAndForgetLog]);

  React.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);



  function disableButton() {
    return formState.data.Cedula.replaceAll("_", "").length !== 11;
  }

function postHeightToParent() {
  if (window.parent !== window) {
    const height = document.body.scrollHeight;
  }
}

  async function submitForm() {
    setIsLoading(true);
    setContactError("");
    setCustomMessage("");
    setFallecido(undefined);
    setShowMessage(false);

    // Only send height to parent when button is clicked
    setTimeout(postHeightToParent, 100);
    const identifier = sanitizeIdentifier(formState.data.Cedula);
    let responseCode: QueryResponseCode = "ERROR";
    let responseMessage = "Error al consultar fallecidos.";
    let responsePayload: any = null;

    try {
      const res = await isFallecido(identifier);
      const fallecidoValue = res?.data?.value;
      responsePayload = fallecidoValue ?? null;

      if (fallecidoValue) {
        if (fallecidoValue.esFallecido && fallecidoValue.esAfiliado) {
          responseCode = "ENCONTRADO";
          responseMessage = "Afiliado fallecido encontrado.";
          setFallecido(fallecidoValue);
          setCustomMessage("");
          setShowMessage(false);
        } else if (!fallecidoValue.esFallecido && fallecidoValue.esAfiliado) {
          responseCode = "NO_ENCONTRADO";
          responseMessage = "El afiliado no figura como fallecido.";
          setCustomMessage(
            "Tu familiar no es un afiliado fallecido pero está afiliado en AFP Crecer."
          );
          setShowMessage(true);
          setFallecido(null);
        } else {
          responseCode = "SIN_DATOS";
          responseMessage = "No hay datos para la cédula consultada.";
          setCustomMessage("");
          setShowMessage(true);
          setFallecido(null);
        }
      } else {
        responseCode = "SIN_DATOS";
        responseMessage = "No hubo respuesta para la cédula consultada.";
        setCustomMessage("");
        setShowMessage(true);
        setFallecido(null);
      }
    } catch (error: any) {
      responseCode = "ERROR";
      responseMessage =
        error?.response?.data?.message ||
        error?.response?.data?.Message ||
        error?.message ||
        "Error al consultar fallecidos.";
      setCustomMessage(
        "Ocurrió un error al realizar la consulta. Intenta nuevamente más tarde."
      );
      setShowMessage(true);
      setFallecido(null);
    } finally {
      setIsLoading(false);
      fireAndForgetLog({
        serviceKey: "FALLECIDOS_CONSULTA",
        identifier,
        responseCode,
        responseMessage,
        responsePayload,
      });
      // Post height again after content changes
      setTimeout(postHeightToParent, 100);
    }
  }
  // Post height when fallecido or showMessage changes
  useEffect(() => {
    postHeightToParent();
  }, [fallecido, showMessage]);

  function handleContactChange(e) {
    const { name, value, type, checked } = e.target;

    setContactForm({
      ...contactForm,
      [name]: type === "checkbox" ? checked : value
    });
  }

  //------------------------------------------
  function handleOnlyLetters(e) {
    const value = e.target.value.replace(
      /[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ\s]/g,
      ""
    );

    setContactForm({
      ...contactForm,
      [e.target.name]: value
    });
  }

  function handleOnlyNumbers(e) {
    const value = e.target.value.replace(/\D/g, "");

    setContactForm({
      ...contactForm,
      [e.target.name]: value
    });
  }

  function resetConsultation() {
    reset();

    setFallecido(undefined);
    setShowMessage(false);
    setCustomMessage("");

    setContactForm({
      nombres: "",
      apellidos: "",
      documento: "",
      telefono: "",
      telefonoOpcional: "",
      correo: "",
      parentesco: "",
      confirmacion: false
    });

    setContactError("");
    setShowPopup(false);

    setTimeout(postHeightToParent, 100);
  }
  //------------------------------------------

  async function handleContactSubmit(e) {
    e.preventDefault();

    setContactError("");

    if (
      !contactForm.nombres ||
      !contactForm.apellidos ||
      !contactForm.documento ||
      !contactForm.telefono ||
      !contactForm.correo ||
      !contactForm.parentesco
    ) {
      setContactError("Por favor completa todos los campos obligatorios.");
      return;
    }

    const onlyLettersRegex =
      /^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ\s]+$/;

    const onlyNumbersRegex = /^\d+$/;

    if (!onlyLettersRegex.test(contactForm.nombres.trim())) {
      setContactError("El campo Nombres solo debe contener letras.");
      return;
    }

    if (!onlyLettersRegex.test(contactForm.apellidos.trim())) {
      setContactError("El campo Apellidos solo debe contener letras.");
      return;
    }

    if (
      contactForm.documento.length < 9 ||
      contactForm.documento.length > 11
    ) {
      setContactError(
        "El Documento de Identidad debe tener entre 9 y 11 caracteres."
      );
      return;
    }

    if (!onlyNumbersRegex.test(contactForm.telefono)) {
      setContactError(
        "El campo Teléfono solo debe contener números y no debe tener espacios."
      );
      return;
    }

    if (
      contactForm.telefonoOpcional &&
      !onlyNumbersRegex.test(contactForm.telefonoOpcional)
    ) {
      setContactError(
        "El campo Teléfono opcional solo debe contener números y no debe tener espacios."
      );
      return;
    }

    if (!contactForm.confirmacion) {
      setContactError(
        "Debes confirmar que la información proporcionada es correcta."
      );
      return;
    }

    if (!fallecido || !fallecido.codPersona) {
      setContactError(
        "No se encontró el afiliado para asociar la solicitud."
      );
      return;
    }

    setContactLoading(true);

    try {
      const response = await sendDeceasedAffiliateEmail({
        phoneNumber: contactForm.telefono,
        optionalPhoneNumber: contactForm.telefonoOpcional,
        name: contactForm.nombres,
        lastName: contactForm.apellidos,
        email: contactForm.correo,
        afiliadoId: fallecido.codPersona,
        nombreAfiliado: `${fallecido.primerNombre} ${fallecido.primerApellido} ${fallecido.segundoApellido}`,
        relationship: contactForm.parentesco,
        documentId: contactForm.documento,
        templateId: "default"
      });

      if (
        response &&
        response.data &&
        (
          response.data.success === true ||
          response.data.success === "true"
        )
      ) {
        setContactError("");
        setShowPopup(true);
        fireAndForgetLog({
          serviceKey: "FALLECIDO_ENVIO_CORREO",
          identifier: sanitizeIdentifier(fallecido.numIdentif || ""),
          responseCode: "ENVIADO",
          responseMessage: "Solicitud de contacto enviada.",
          responsePayload: {
            contacto: {
              nombres: contactForm.nombres,
              apellidos: contactForm.apellidos,
              documento: contactForm.documento,
              telefono: contactForm.telefono,
              telefonoOpcional: contactForm.telefonoOpcional,
              correo: contactForm.correo,
              parentesco: contactForm.parentesco,
            },
            afiliado: fallecido.codPersona,
          },
        });
      } else {
        setContactError(
          "Ocurrió un error al enviar la solicitud. Intenta nuevamente más tarde."
        );
      }
    } catch (err: any) {
      setContactError(
        "Ocurrió un error al enviar la solicitud. Intenta nuevamente más tarde."
      );
      fireAndForgetLog({
        serviceKey: "FALLECIDO_ENVIO_CORREO",
        identifier: sanitizeIdentifier(fallecido?.numIdentif || ""),
        responseCode: "NO_ENVIADO",
        responseMessage:
          err?.response?.data?.message ||
          err?.response?.data?.Message ||
          err?.message ||
          "No se pudo enviar el correo de contacto.",
        responsePayload: {
          contacto: {
            nombres: contactForm.nombres,
            apellidos: contactForm.apellidos,
            documento: contactForm.documento,
            telefono: contactForm.telefono,
            telefonoOpcional: contactForm.telefonoOpcional,
            correo: contactForm.correo,
            parentesco: contactForm.parentesco,
          },
          afiliado: fallecido?.codPersona ?? null,
        },
      });
    }

    setContactLoading(false);
  }

  return (
    <section className="content-consultation-deceased-affiliate">
      <div className="container">
        <div className="description">
          <div
            className="title wow fadeInUp"
            data-wow-duration="1.5s"
            data-wow-delay="0.4s"
          >
            <p>
              Te estamos buscando porque contamos con más de 2 mil millones de pesos pertenecientes a 23 mil personas fallecidas, que no han sido reclamados por sus familiares.
            </p>
            <p>
              Si perdiste un familiar y no sabes si era afiliado de AFP Crecer, digita su número de cédula de identidad en el siguiente campo, y si era afiliado, anímate ya a iniciar el proceso de solicitud de {" "}
              <a
                target="_blank"
                className="custom-link"
                href={Constants.RESOURCESURLS.PENSION_SOBREVIVENCIA}
                style={{ color: '#2563eb', textDecoration: 'underline', fontWeight: 500 }}
              >
                Pensión por Sobrevivencia o la devolución a herederos legales.
              </a>
            </p>
          </div>
          <div
            className={`sticky-form-wrapper ${
              isLoading && !scrolled ? "bg-transparent" : "bg-white"
            }`}
          >
            <form
              onSubmit={(e) => e.preventDefault()}
              className="sticky-form-vertical"
            >
              <label htmlFor="cedula" className="sticky-label">
                Documento de identidad del fallecido
              </label>
              <div className="sticky-inline-group">
                <InputMask
                  id="cedula"
                  type="text"
                  className="sticky-input"
                  placeholder="000-0000000-0"
                  value={formState.data.Cedula}
                  onChange={changeHandler("Cedula", undefined, "-")}
                  mask="999-9999999-9"
                  maskPlaceholder={"_"}
                />
                <button
                  type="button"
                  onClick={() => {
                    setFallecido(null);
                    setShowMessage(false);
                    submitForm();
                  }}
                  disabled={disableButton()}
                  className="sticky-button"
                >
                  Consultar
                </button>
              </div>
            </form>
          </div>

          {/* Se muestra info de afiliado  */}
          {fallecido && (
            <div className="deceased-member-information">
              <div className="title-member">
                <h5>Información del Afiliado fallecido</h5>
              </div>
              <div style={{ background: '#EEFAFA', color: '#24A49E', borderRadius: 8, padding: '12px 16px', marginBottom: 16, display: 'flex', alignItems: 'center' }}>
                <svg xmlns="http://www.w3.org/2000/svg" style={{ width: 28, height: 28, marginRight: 12, flexShrink: 0 }} fill="none" viewBox="0 0 24 24" stroke="#24A49E" strokeWidth={2}>
                  <circle cx="12" cy="12" r="10" stroke="#24A49E" strokeWidth="2" fill="#ECFDF5" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4" />
                </svg>
                <span style={{ fontWeight: 600, fontSize: 16 }}>Sí, tu familiar estuvo afiliado con nosotros. Lamentamos tu pérdida.</span>
              </div>
              
<div className="custom-info-card">
  <h6 className="custom-info-title">Datos del Afiliado</h6>
  <ul className="custom-info-list">
    <li>
      <span>Número de Identificación</span>
      <b>{fallecido.numIdentif}</b>
    </li>
    <li>
      <span>Nombre y Apellido</span>
      <b>{fallecido.primerNombre} {fallecido.primerApellido} {fallecido.segundoApellido}</b>
    </li>
    <li>
      <span>Edad</span>
      <b></b>
    </li>
    <li>
      <span>Correo Electrónico</span>
      <b>{fallecido.correo}</b>
    </li>
    <li>
      <span>Teléfono</span>
      <b>{fallecido.telefono}</b>
    </li>
  </ul>
</div>
<div className="custom-description">
  <p>
    Puedes proceder con la solicitud de <strong>Pensión por Sobrevivencia</strong>. Si prefieres una asistencia personalizada, completa tus datos y te estaremos contactando para acompañarte en el proceso.
  </p>
</div>
              <form className="custom-info-card custom-form" onSubmit={handleContactSubmit}>
                <h6 className="custom-info-title">Tus datos de contacto</h6>
                <div className="custom-form-grid">
                  <div className="custom-group">
                    <label htmlFor="nombres">Nombres</label>
                    <input type="text" id="nombres" name="nombres" required value={contactForm.nombres} onChange={handleOnlyLetters} />
                  </div>
                  <div className="custom-group">
                    <label htmlFor="apellidos">Apellidos</label>
                    <input type="text" id="apellidos" name="apellidos" required value={contactForm.apellidos} onChange={handleOnlyLetters} />
                  </div>
                  <div className="custom-group">
                    <label htmlFor="documento">No. Documento de Identidad</label>
                    <input type="text" id="documento" name="documento" required value={contactForm.documento} minLength={9} maxLength={11} onChange={handleContactChange} />
                  </div>
                  <div className="custom-group">
                    <label htmlFor="telefono">Teléfono</label>
                    <input type="text" id="telefono" name="telefono" required value={contactForm.telefono} onChange={handleOnlyNumbers} />
                  </div>
                  <div className="custom-group">
                    <label htmlFor="telefonoOpcional">Teléfono opcional</label>
                    <input type="text" id="telefonoOpcional" name="telefonoOpcional" value={contactForm.telefonoOpcional} onChange={handleOnlyNumbers} />
                  </div>
                  <div className="custom-group">
                    <label htmlFor="correo">Correo Electrónico</label>
                    <input type="email" id="correo" name="correo" required value={contactForm.correo} onChange={handleContactChange} />
                  </div>
                  <div className="custom-group">
                    <label htmlFor="parentesco">Parentesco con el fallecido</label>
                    <select id="parentesco" name="parentesco" required value={contactForm.parentesco} onChange={handleContactChange}>
                      <option value="">Selecciona</option>
                      <option value="Hijo(a)">Hijo(a)</option>
                      <option value="Padre/Madre">Padre/Madre</option>
                      <option value="Cónyuge">Cónyuge</option>
                      <option value="Hermano(a)">Hermano (a)</option>
                      <option value="Familiar Cercano ">Familiar Cercano </option>
                    </select>
                  </div>
                </div>

                <div className="custom-confirmation">
                  <label htmlFor="confirmacion">
                    <input
                      type="checkbox"
                      id="confirmacion"
                      name="confirmacion"
                      checked={contactForm.confirmacion}
                      onChange={handleContactChange}
                    />

                    <span>
                      Confirmo y estoy seguro de que la información proporcionada
                      es la correcta y no tiene errores
                    </span>
                  </label>
                </div>

                {contactError && <div className="custom-error-message">{contactError}</div>}

                <div className="custom-actions">
                  <button type="submit" disabled={contactLoading || !contactForm.confirmacion}>
                    {contactLoading ? "Enviando..." : "Enviar Solicitud"}
                  </button>
                </div>
              </form>
              <div className="custom-description">
                <p>
                  Si deseas conocer los requisitos y documentación necesaria para solicitar la <strong>Pensión por Sobrevivencia</strong>, haz clic en este enlace.
                  <br />
                  Recuerda que puedes solicitarla <strong>sin costo alguno</strong> y con <strong>asesoría legal totalmente gratis</strong>, no necesitas intermediarios.
                </p>
                <p style={{ marginTop: '10px' }}>
                  <a
                    href="https://afpcrecer.com.do/mis-beneficios/pension-por-sobrevivencia/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="custom-link"
                  >
                    Ver requisitos y documentación de pensión por sobrevivencia
                  </a>
                </p>
              </div>

            </div>
          )}
          {/* Mensaje de error si no aparece */}
          {showMessage && (
            <div className="deceased-member-information">
              <div>
                <div style={{ display: 'flex', alignItems: 'center', background: '#FFF7F8', borderRadius: 8, padding: '12px 16px', marginBottom: 16 }}>
                  <svg xmlns="http://www.w3.org/2000/svg" style={{ width: 28, height: 28, marginRight: 12, flexShrink: 0 }} fill="none" viewBox="0 0 24 24" stroke="#F38C7E" strokeWidth={2}>
                    <circle cx="12" cy="12" r="10" stroke="#F38C7E" strokeWidth="2" fill="#FFF7F8" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01" />
                  </svg>
                  <span style={{ fontWeight: 600, fontSize: 16, color: '#F38C7E' }}>{customMessage || 'Tu familiar no estuvo afiliado con nosotros.'}</span>
                </div>
                {!customMessage && (
                  <p style={{ marginTop: "1em" }}>
                    <b>Lamentamos tu pérdida.</b> Puedes consultar cuál era la AFP de tu
                    familiar fallecido en el portal de fallecidos de la
                    Superintendencia de Pensiones (SIPEN). 
                    <a
                      href="https://www.sipen.gob.do/servicios/consulta-afiliados-fallecidos-del-sistema-dominicano-de-pensiones"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#2563eb', textDecoration: 'underline', fontWeight: 500 }}
                    > Haz clic en este enlace</a> y verifícalo.
                    <p><b><br></br>Si estás seguro de que tu familiar era afiliado de AFP Crecer, contáctanos al <a href="https://wa.me/8096583888" target="_blank" rel="noopener noreferrer"
                      style={{ color: '#2563eb', textDecoration: 'underline', fontWeight: 500 }}>8096583888</a> o a nuestro centro de contacto al 8096884040.</b></p>
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>


    {showPopup && (
      <div className="custom-popup-overlay">
        <div className="custom-popup">
          <button
            type="button"
            className="custom-popup-close"
            onClick={resetConsultation}
          >
            ×
          </button>

          <div className="custom-popup-icon">
            ✓
          </div>

          <h5>¡Solicitud enviada correctamente!</h5>

          <p>
            Pronto te contactaremos.
          </p>

          <button
            type="button"
            className="custom-popup-button"
            onClick={resetConsultation}
          >
            Aceptar
          </button>
        </div>
      </div>
    )}
    </section>
  );
};

export default WithMainLayout(DeceasedAffiliate);
